export function scrollIntoViewHorizontal(
  scrollView: HTMLElement,
  element: HTMLElement,
  scrollPadding: number,
  isSmooth = true
): void {
  const offsetX = element.offsetLeft - scrollView.offsetLeft;
  const width = element.offsetWidth;
  let x = scrollView.scrollLeft;

  const viewBoundaryLeft = scrollView.scrollLeft + scrollPadding;
  const viewBoundaryRight =
    scrollView.scrollLeft + scrollView.clientWidth - scrollPadding;

  const isInView =
    offsetX >= viewBoundaryLeft && offsetX + width <= viewBoundaryRight;

  if (!isInView) {
    if (offsetX <= viewBoundaryLeft) {
      x = offsetX - scrollPadding;
    } else {
      x = offsetX + width + scrollPadding - scrollView.clientWidth;
    }

    scrollView.scrollTo({
      left: x,
      behavior: isSmooth ? 'smooth' : 'auto',
    });
  }
}
